import { formatCurrencyNullable } from './currency';

/**
 * Formatação de dinheiro que cruza a API como **string decimal exata**
 * (`'1100.00'`), e não como `number`.
 *
 * Mora em `shared` porque as duas superfícies do financeiro arbitral leem os
 * mesmos fatos: a da Secretaria e a da empresa. Enquanto viveu só em
 * `secretaria-arbitral`, a aba do cliente somava em float com régua própria — e
 * os três números do resumo divergiam da lista.
 */
export function formatarValorDecimal(valor: string | null): string {
  if (valor === null || valor.trim() === '') return '—';
  return formatCurrencyNullable(valor) ?? '—';
}

/** Zero, vazio e lixo não-numérico contam como "nada a mostrar". */
export function ehZero(valor: string | null): boolean {
  if (valor === null || valor.trim() === '') return true;
  const numero = Number(valor);
  return !Number.isFinite(numero) || numero === 0;
}
